import { ChangeDetectionStrategy, Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'planday-edit-container',
    templateUrl: './planday-edit-container.component.html',
    styleUrls: ['./planday-edit-container.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'planday-edit-container' },
    standalone: false,
})
export class PlandayEditContainerComponent extends TabsModuleBase implements OnInit {
    constructor(
        injector: Injector,
        private appTextService: AppTextService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.tabs.push({
            Title: this.appTextService.get('settings'),
            Sref: FiStateNames.OtherSettings.Planday.Settings,
        });

        this.tabs.push({
            Title: this.appTextService.get('pk.match_roles'),
            Sref: FiStateNames.OtherSettings.Planday.RolesMatching,
        });

        this.tabs.push({
            Title: this.appTextService.get('pk.matching_units_import'),
            Sref: FiStateNames.OtherSettings.Planday.ImportUnits,
        });

        this.tabs.push({
            Title: this.appTextService.get('pk.match_units'),
            Sref: FiStateNames.OtherSettings.Planday.UnitsMatching,
        });

        this.tabs.push({
            Title: this.appTextService.get('planday.match_units_with_areas_and_business_areas'),
            Sref: FiStateNames.OtherSettings.Planday.MatchUnitsWithAreas,
        });

        this.tabs.push({
            Title: this.appTextService.get('pk.user_import'),
            Sref: FiStateNames.OtherSettings.Planday.ImportUsers,
        });

        this.tabs.push({
            Title: this.appTextService.get('pk.match_users'),
            Sref: FiStateNames.OtherSettings.Planday.UsersMatching,
        });

        this.tabs.push({
            Title: this.appTextService.get('pk.import_log'),
            Sref: FiStateNames.OtherSettings.Planday.ImportLog,
        });

        super.updateSelectedTabFromState();
    }
}
